import * as React from "react";
import * as SwitchPrimitives from "@radix-ui/react-switch";

import { cn } from "../../utils";

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      "al-peer al-inline-flex al-h-6 al-w-11 al-shrink-0 al-cursor-pointer al-items-center al-rounded-full al-border-2 al-border-transparent al-transition-colors focus-visible:al-outline-none focus-visible:al-ring-2 focus-visible:al-ring-ring focus-visible:al-ring-offset-2 focus-visible:al-ring-offset-background disabled:al-cursor-not-allowed disabled:al-opacity-50 data-[state=checked]:al-bg-primary data-[state=unchecked]:al-bg-input",
      className
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        "al-pointer-events-none al-block al-h-5 al-w-5 al-rounded-full al-bg-background al-shadow-lg al-ring-0 al-transition-transform data-[state=checked]:al-translate-x-5 data-[state=unchecked]:al-translate-x-0"
      )}
    />
  </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
